import request from '@/utils/request'
import URL from '@/api/urlTranslator'

export function uploadStorage(body) {
  const data = new FormData()
  for (const key in body) {
    data.append(key, body[key])
  }
  return request({
    url: URL.common.uploadStorage,
    config: {
      headers: {
        'Content-Type': 'multipart/form-data; charset=UTF-8'
      }
    },
    method: 'post',
    data
  })
}

export function uploadBillPaymentStorage(body) {
  const data = new FormData()
  for (const key in body) {
    data.append(key, body[key])
  }
  return request({
    url: URL.act.billPayment.uploadBillPaymentStorage,
    config: {
      headers: {
        'Content-Type': 'multipart/form-data; charset=UTF-8'
      }
    },
    method: 'post',
    data
  })
}

export function batchUploadStorage(body) {
  const data = new FormData()
  for (const key in body) {
    data.append(key, body[key])
  }
  return request({
    url: URL.common.matchUploadStorage,
    config: {
      headers: {
        'Content-Type': 'multipart/form-data; charset=UTF-8'
      }
    },
    method: 'post',
    data
  })
}

export function getFileList(xmlParam) {
  const data = new FormData()
  data.append('xmlParam', xmlParam)
  return request({
    url: URL.common.fileList,
    method: 'post',
    data
  })
}

// 获取文件列表（传多个参数）
export function getFileListByMultiParam(xmlParamList) {
  return request({
    url: URL.common.fileListByMultiParam,
    method: 'post',
    data: xmlParamList
  })
}

export function deleteFile(fileId, data) {
  if (!data) {
    data = {}
  }
  return request({
    url: URL.common.deleteFile + '/' + encodeURIComponent(fileId),
    method: 'post',
    data
  })
}

export function saveMetaData(xmlParam) {
  const data = new FormData()
  data.append('xmlParam', xmlParam)
  return request({
    url: URL.common.saveMetaData,
    method: 'post',
    data
  })
}

export function synchronizationFile(data, jobKey) {
  return request({
    url: URL.common.synchronizationFile,
    method: 'post',
    data,
    params: { jobKey }
  })
}

// 通过多个job同步云存储文件
export function synchronizationFileByJobs(data) {
  return request({
    url: URL.common.synchronizationFileByJobs,
    method: 'post',
    data
  })
}

export function cancelSynchronization(data, jobKey) {
  return request({
    url: URL.common.cancelSynchronization,
    method: 'post',
    data,
    params: { jobKey }
  })
}

// 通过多个job取消同步云存储文件
export function cancelSynchronizationByJobs(data) {
  return request({
    url: URL.common.cancelSynchronizationByJobs,
    method: 'post',
    data
  })
}

export function findByFileId(fileId) {
  return request({
    url: URL.common.findByFileId + '/' + encodeURIComponent(fileId),
    responseType: 'blob',
    method: 'get'
  })
}

export function getFileInfo(fileId) {
  return request({
    url: URL.common.getFileInfo + '/' + encodeURIComponent(fileId),
    method: 'get'
  })
}

export function convertFileByFileId(fileId, targetFileType) {
  return request({
    url: URL.common.convertFileByFileId + '/' + encodeURIComponent(fileId) + '/' + targetFileType,
    responseType: 'blob',
    method: 'get'
  })
}

// 通过多个job同步云存储文件
export function syncJobFiles(body) {
  const data = new FormData()
  for (const key in body) {
    data.append(key, body[key])
  }
  return request({
    url: URL.common.syncJobFiles,
    method: 'post',
    data
  })
}

// 取消同步job文件
export function cancelSyncJobFiles(body) {
  const data = new FormData()
  for (const key in body) {
    data.append(key, body[key])
  }
  return request({
    url: URL.common.cancelSyncJobFiles,
    method: 'post',
    data
  })
}
